var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-lateral',{ref:"modalChatearAsesor",attrs:{"titulo":"Asesor de leeche"}},[_vm._v(" chat con asesor ")])}
var staticRenderFns = []

export { render, staticRenderFns }